import { render, staticRenderFns } from "./HeartEmpty.vue?vue&type=template&id=b5fa3844&"
import script from "./HeartEmpty.vue?vue&type=script&lang=js&"
export * from "./HeartEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports